import { Dispatch, SetStateAction } from 'react';
import { NavigateFunction } from 'react-router';

export const ADMINISTRATION_SEARCH_QUERY_KEY = 'search';

export type AdministrationSearchFilters = {
  searchInput: string;
  appliedSearch: string;
  page: number;
};

export const buildAdministrationSearchPath = (
  pathname: string,
  searchValue: string
): string => {
  const trimmedSearch = searchValue.trim();
  if (!trimmedSearch) {
    return pathname;
  }
  const searchParameters = new URLSearchParams();
  searchParameters.set(ADMINISTRATION_SEARCH_QUERY_KEY, trimmedSearch);
  return `${pathname}?${searchParameters.toString()}`;
};

export const applyAdministrationSearchToSearchParams = (
  currentSearchParameters: URLSearchParams,
  searchValue: string
): URLSearchParams => {
  const nextSearchParameters = new URLSearchParams(currentSearchParameters);
  const trimmedSearch = searchValue.trim();
  if (trimmedSearch) {
    nextSearchParameters.set(ADMINISTRATION_SEARCH_QUERY_KEY, trimmedSearch);
  } else {
    nextSearchParameters.delete(ADMINISTRATION_SEARCH_QUERY_KEY);
  }
  return nextSearchParameters;
};

export const openAdministrationViewWithSearch = <
  T extends AdministrationSearchFilters
>(
  navigate: NavigateFunction,
  targetPath: string,
  searchValue: string,
  setTargetFilters: Dispatch<SetStateAction<T>>,
  additionalPatch?: Partial<T>
): void => {
  const trimmedSearch = searchValue.trim();
  setTargetFilters((current) => ({
    ...current,
    searchInput: trimmedSearch,
    appliedSearch: trimmedSearch,
    page: 0,
    ...additionalPatch
  }));
  navigate(buildAdministrationSearchPath(targetPath, trimmedSearch));
};
